<template>
  <div>
    <div
      class="card-padding-x card-padding-top d-flex justify-content-center justify-content-sm-start align-items-center"
    >
      <div
        class="d-flex stepper"
        :class="[currentStep === 1 ? 'current-step' : 'previous-step']"
      >
        <div class="stepper-order mr-1">
          <span class="font-size-20 font-weight-600">1</span>
        </div>
        <div class="d-none d-sm-block">
          <span class="d-block font-weight-600 stepper-topic">
            Escalation Detail
          </span>
          <span class="d-block font-size-12 text-color-grey">
            Basic Information
          </span>
        </div>
        <div class="d-flex align-items-center d-sm-none">
          <span class="d-block font-weight-600 stepper-topic"> Detail </span>
        </div>
      </div>
      <div class="d-flex justify-content-center align-content-center mx-2">
        <feather-icon size="20" icon="ChevronRightIcon" />
      </div>
      <div
        class="d-flex stepper"
        :class="[currentStep === 2 ? 'current-step' : 'next-step']"
      >
        <div class="stepper-order mr-1">
          <span class="font-size-20 font-weight-600">2</span>
        </div>
        <div class="d-none d-sm-block">
          <span class="d-block font-weight-600 stepper-topic">
            Escalation Criteria
          </span>
          <span class="d-block font-size-12 text-color-grey">
            Define Rule
          </span>
        </div>
        <div class="d-flex align-items-center d-sm-none">
          <span class="d-block font-weight-600 stepper-topic"> Criteria </span>
        </div>
      </div>
    </div>
    <hr />
    <div class="card-padding-x">
      <slot v-if="currentStep === 1" name="first-step-content"></slot>
      <slot v-else name="second-step-content"></slot>
    </div>
    <div class="card-padding d-flex justify-content-between mt-1">
      <atom-button
        buttonId="go-to-next-step-button"
        buttonStyle="border"
        buttonColor="secondary"
        :class="{ 'hidden-content': currentStep === 1 }"
        @click="clickGoToPreviousStep"
      >
        <feather-icon
          size="14"
          icon="ChevronLeftIcon"
          class="custom-margin-right-6"
        />
        <span>Previous</span>
      </atom-button>
      <div :class="{ 'd-none': currentStep === 2 }">
        <atom-button
          buttonId="go-to-next-step-button"
          :is-disable="isDisableNextButton"
          :class="[currentStep === 1 ? 'd-flex justify-self-end' : 'd-none']"
          @click="clickGoToNextStep"
        >
          <span>Next</span>
          <feather-icon
            size="14"
            icon="ChevronRightIcon"
            class="custom-margin-left-6"
          />
        </atom-button>
      </div>
      <div :class="{ 'd-none': currentStep === 1 }">
        <atom-button
          buttonId="create-button"
          class="d-flex justify-self-end"
          :is-disable="isDisableSubmitButton"
          @click="clickSubmitButton"
        >
          <span>{{ textSubmitBtn }}</span>
        </atom-button>
      </div>
    </div>
  </div>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
export default {
  name: "MoleculeEscalationStepper",
  components: {
    AtomButton,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    isDisableNextButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisableSubmitButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    textSubmitBtn: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["onClickPreviousStepBtn", "onClickNextStepBtn", "onClickCreateBtn"],

  data() {
    return {}
  },

  mounted() {},

  methods: {
    clickGoToPreviousStep() {
      this.$emit("onClickPreviousStepBtn")
    },
    clickGoToNextStep() {
      this.$emit("onClickNextStepBtn")
    },
    clickSubmitButton() {
      this.$emit("onClickSubmitBtn")
    },
  },
}
</script>

<style lang="scss" scoped>
.stepper-order {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  width: 38px;
  height: 38px;
  padding: 10px;
}

.stepper.previous-step {
  .stepper-order {
    background-color: #eeecfd;
    color: #7367f0;
    box-shadow: 0px 2px 5px rgba(114, 102, 239, 0.3);
  }
  .stepper-topic {
    color: #babfc7;
  }
  &:hover {
    cursor: pointer;
  }
}

.stepper.current-step {
  .stepper-order {
    background-color: #7367f0;
    color: #ffffff;
    box-shadow: 0px 2px 5px rgba(114, 102, 239, 0.3);
  }
  .stepper-topic {
    color: #7367f0;
  }
}

.stepper.next-step {
  .stepper-order {
    background-color: #f6f7f8;
    color: #babfc7;
  }
  .stepper-topic {
    color: #babfc7;
  }
}

.hidden-content {
  visibility: hidden;
}
</style>
